import { Field, OrderFormFields } from 'components/DocumentDetail/types'
import { DocumentOrderForm } from 'entities/DocumentsOrderForm'
import applyErrorMsg from 'utils/applyErrorMsg'

export const FIELDS: { [section: string]: Field[] } = {
  headerBase: [
    {
      name: 'orderFormDate',
      type: 'date',
      testid: 'order-form-date',
      rules: {
        // required: true,
        validate: (v: Date | string) => {
          const v1 = v instanceof Date ? v : new Date(v)
          // error msg is '' becaouse error message is displayed by datepicker
          return isNaN(v1.getTime())
            ? /* ERROR_TEXT.dateFormat */ ''
            : undefined
        },
      },
    },
    {
      name: 'orderFormNo',
      testid: 'order-form-no',
      type: 'text',
      rules: {
        // required: true,
        maxLength: 50,
      },
    },
    {
      name: 'subjectTitle',
      type: 'text',
      testid: 'subject-title',
      rules: {
        // required: true,
        maxLength: 100,
      },
    },
    {
      name: 'deliveryDate',
      type: 'date',
      testid: 'delivery-date',
      rules: {
        /* required: false, */ // not required but date type is checked
        validate: (v: Date | string) => {
          if (v instanceof Date) {
            // Dateの場合、画面から操作した
            return isNaN(v.getTime())
              ? /* ERROR_TEXT.dateFormat */ ''
              : undefined
          }
        },
      },
    },
    {
      name: 'paymentTerms',
      type: 'text',
      testid: 'payment-terms',
    },
    {
      name: 'totalAmountTaxIn',
      type: 'number',
      testid: 'total-amount-tax-in',
    },
    {
      name: 'totalAmountTaxEx',
      type: 'number',
      testid: 'total-amount-tax-ex',
    },
    {
      name: 'totalTax',
      type: 'number',
      testid: 'total-tax',
    },
    {
      name: 'taxInfo',
      type: 'text',
      testid: 'tax-info',
    },
    {
      name: 'totalPrice8',
      type: 'number',
      testid: 'total-price8',
    },
    {
      name: 'totalPrice10',
      type: 'number',
      testid: 'total-price10',
    },
    {
      name: 'totalPrice',
      type: 'number',
      testid: 'total-price',
    },
    {
      name: 'subTotalPrice8',
      type: 'number',
      testid: 'sub-total-price8',
    },
    {
      name: 'subTotalPrice10',
      type: 'number',
      testid: 'sub-total-price10',
    },
    {
      name: 'subTotalPrice',
      type: 'number',
      testid: 'sub-total-price',
    },
    {
      name: 'taxAmount8',
      type: 'number',
      testid: 'tax-amount8',
    },
    {
      name: 'taxAmount10',
      type: 'number',
      testid: 'tax-amount10',
    },
    {
      name: 'taxAmount',
      type: 'number',
      testid: 'tax-amount',
    },
    {
      name: 'taxAmountInfo',
      testid: 'tax-amount-info',
    },
    {
      name: 'discount',
      type: 'number',
      testid: 'discount',
    },
    {
      name: 'currency',
      testid: 'currency',
    },
    {
      name: 'otherDate',
      type: 'date',
      testid: 'other-date',
      rules: {
        /* required: false, */ // not required but date type is checked
        validate: (v: Date | string) => {
          if (v instanceof Date) {
            // Dateの場合、画面から操作した
            return isNaN(v.getTime())
              ? /* ERROR_TEXT.dateFormat */ ''
              : undefined
          }
        },
      },
    },
    {
      name: 'otherNum',
      testid: 'other-num',
    },
    {
      name: 'etcAmount',
      type: 'number',
      testid: 'etc-amount',
    },
  ],
  headerOrderer: [
    {
      name: 'companyName',
      testid: 'header-orderer-company-name',
    },
    {
      name: 'department',
      testid: 'header-orderer-department',
    },
    {
      name: 'personName',
      testid: 'header-orderer-person-name',
    },
    {
      name: 'owner',
      testid: 'header-orderer-owner',
    },
    {
      name: 'postalCode',
      testid: 'header-orderer-postal-code',
    },
    {
      name: 'address',
      testid: 'header-orderer-address',
    },
    {
      name: 'tel',
      testid: 'header-orderer-tel',
    },
    {
      name: 'fax',
      testid: 'header-orderer-fax',
    },
    {
      name: 'email',
      testid: 'header-orderer-email',
    },
    {
      name: 'homepage',
      testid: 'header-orderer-homepage',
    },
  ],
  headerSupplier: [
    {
      name: 'companyName',
      testid: 'header-supplier-company-name',
    },
    {
      name: 'department',
      testid: 'header-supplier-department',
    },
    {
      name: 'personName',
      testid: 'header-supplier-person-name',
    },
    {
      name: 'postalCode',
      testid: 'header-supplier-postal-code',
    },
    {
      name: 'address',
      testid: 'header-supplier-address',
    },
    {
      name: 'tel',
      testid: 'header-supplier-tel',
    },
    {
      name: 'fax',
      testid: 'header-supplier-fax',
    },
  ],
  headerDelivery: [
    {
      name: 'companyName',
      testid: 'header-delivery-company-name',
    },
    {
      name: 'department',
      testid: 'header-delivery-department',
    },
    {
      name: 'personName',
      testid: 'header-delivery-person-name',
    },
    {
      name: 'postalCode',
      testid: 'header-delivery-postal-code',
    },
    {
      name: 'address',
      testid: 'header-delivery-address',
    },
    {
      name: 'tel',
      testid: 'header-delivery-tel',
    },
    {
      name: 'fax',
      testid: 'header-delivery-fax',
    },
    {
      name: 'etc',
      testid: 'header-delivery-etc',
    },
  ],
  other: [
    {
      name: 'note',
      testid: 'note',
      compProps: { multiline: true },
    },
  ],
  itemLine: [
    {
      name: 'order',
      type: 'hidden',
      testid: 'item-line-order',
    },
    {
      name: 'num',
      testid: 'item-line-num',
    },
    {
      name: 'name',
      testid: 'item-line-name',
      rules: {
        // required: true,
      },
    },
    {
      name: 'taxIncludedUnitPrice',
      type: 'number',
      testid: 'item-line-tax-included-unit-price',
    },
    {
      name: 'taxExcludedUnitPrice',
      type: 'number',
      testid: 'item-line-tax-excluded-unit-price',
    },
    {
      name: 'count',
      type: 'number',
      testid: 'item-line-count',
    },
    {
      name: 'quantityUnit',
      testid: 'item-line-quantity-unit',
    },
    {
      name: 'date',
      type: 'date',
      testid: 'item-line-date',
    },
    {
      name: 'taxIncludedPrice',
      type: 'number',
      testid: 'item-line-tax-included-price',
    },
    {
      name: 'taxExcludedPrice',
      type: 'number',
      testid: 'item-line-tax-excluded-price',
    },
    {
      name: 'taxAmount',
      type: 'number',
      testid: 'item-line-tax-amount',
    },
    {
      name: 'taxInfo',
      testid: 'item-line-tax-info',
    },
    {
      name: 'discount',
      type: 'number',
      testid: 'item-line-discount',
    },
    {
      name: 'currency',
      testid: 'item-line-currency',
    },
    {
      name: 'etc',
      testid: 'item-line-etc',
    },
  ],
}

// general fields generator
function genSectionFields(
  sectionName: string,
  doc: DocumentOrderForm,
): Field[] {
  const { docInfo, ocrResp, config, isNew } = doc

  return (
    FIELDS[sectionName]
      // check visibility
      // .filter(field => )
      // update name & inject detectedPage to each field
      .map((field) => {
        const disabled =
          !config?.[sectionName]?.[field.name]?.edit ||
          field?.compProps?.disabled

        let required = field.rules?.required
        // verifyの場合
        if (
          docInfo.isVerify &&
          !isNew &&
          !config?.[sectionName]?.[field.name]?.verify
        ) {
          required = false
        }
        return {
          ...field,
          label: doc.getLabel(sectionName, field.name),
          name: `${sectionName}.${field.name}`,
          confidence: ocrResp[sectionName]?.[field.name]?.confidenceScore,
          rules: applyErrorMsg({
            ...field?.rules,
            required,
          }),
          compProps: { ...field?.compProps, disabled },
          config: config?.[sectionName]?.[field.name],
        }
      })
  )
}

function genItemDefaultField(doc: DocumentOrderForm): Field[] {
  const { config, docInfo } = doc
  const { isNew } = doc

  const sectionName = 'itemLines' // itemLines vs itemLine

  return (
    FIELDS.itemLine
      // check visibility
      // .filter(field => )
      // update name & inject detectedPage to each field
      .map((field) => {
        const disabled =
          !config?.[sectionName]?.[field.name]?.edit ||
          field?.compProps?.disabled

        let required = field.rules?.required
        // verifyの場合
        if (
          docInfo.isVerify &&
          !isNew &&
          !config?.[sectionName]?.[field.name]?.verify
        ) {
          required = false
        }
        return {
          ...field,
          id: undefined,
          label: doc.getLabel(sectionName, field.name),
          confidence: undefined,
          rules: applyErrorMsg({
            ...field?.rules,
            required,
          }),
          compProps: { ...field?.compProps, disabled },
          config: config?.[sectionName]?.[field.name],
        }
      })
  )
}

// items fields generator
function genItemFields(doc: DocumentOrderForm): Field[][] {
  const { config, ocrResp } = doc

  if (!ocrResp.itemLines) {
    return []
  }
  const sectionName = 'itemLines'

  return ocrResp.itemLines.map((ocrItemLine) => {
    const rtn = FIELDS.itemLine
      // check visibility
      .filter((field) => config?.[sectionName]?.[field.name])
      // update name
      .map((field) => {
        const disabled =
          config?.itemLines?.[field.name].edit === false ||
          field?.compProps?.disabled
        return {
          ...field,
          id: ocrItemLine.id,
          label: doc.getLabel(sectionName, field.name),
          confidence: ocrItemLine[field.name]?.confidenceScore,
          rules: applyErrorMsg(field.rules),
          compProps: { ...field?.compProps, disabled },
          config: config?.itemLines?.[field.name],
        }
      })
    rtn.unshift(ocrItemLine.id as any) // TODO: refactor: there's no way to store order
    return rtn
  })
}

export default function getOrderFormFields(
  doc: DocumentOrderForm,
): OrderFormFields {
  return {
    headerBase: genSectionFields('headerBase', doc),
    headerOrderer: genSectionFields('headerOrderer', doc),
    headerSupplier: genSectionFields('headerSupplier', doc),
    headerDelivery: genSectionFields('headerDelivery', doc),
    other: genSectionFields('other', doc),
    itemLines: genItemFields(doc) as any, // TODO: refactor: sorry for any
    itemDefaultField: genItemDefaultField(doc),
  }
}
